/* casam-geo-block.js — Casa M native geo-block (EXTERNAL asset).
   Replaces the inline snippet that rendered as raw HTML and broke the storefront 2026-06-07.
   Fail-open, client-side block of the ISO-2 country codes in BLOCK_LIST (CN only — mirrors
   the prior Unicorn Geo Blocker config). Never runs in the theme editor.
   Owner/test bypass: append ?geoblock_off=1 to any URL (persists in that browser);
   re-enable with ?geoblock_on=1. */
(function () {
  var BLOCK_LIST = ["CN"];
  var TITLE = "BLOCKED";
  var MESSAGE = "This store is not available in your country.";

  if (window.Shopify && window.Shopify.designMode) { return; }

  try {
    var qs = window.location.search || "";
    if (qs.indexOf("geoblock_on=1") > -1) { localStorage.removeItem("casam_geoblock_off"); }
    if (qs.indexOf("geoblock_off=1") > -1) { localStorage.setItem("casam_geoblock_off", "1"); }
    if (localStorage.getItem("casam_geoblock_off") === "1") { return; }
  } catch (e) {}

  function blockPage() {
    try {
      var html = ''
        + '<head><meta charset="utf-8">'
        + '<meta name="viewport" content="width=device-width,initial-scale=1">'
        + '<title>' + TITLE + '</title></head>'
        + '<body style="margin:0;min-height:100vh;display:flex;align-items:center;'
        + 'justify-content:center;font-family:-apple-system,BlinkMacSystemFont,Segoe UI,'
        + 'Roboto,Helvetica,Arial,sans-serif;background:#1a1a1a;color:#fff;text-align:center;'
        + 'padding:24px;"><div>'
        + '<h1 style="font-size:1.6rem;letter-spacing:.08em;margin:0 0 12px;">' + TITLE + '</h1>'
        + '<p style="font-size:1rem;opacity:.85;margin:0;">' + MESSAGE + '</p>'
        + '</div></body>';
      document.documentElement.innerHTML = html;
    } catch (e) {}
    try { window.stop(); } catch (e) {}
  }

  fetch("/cdn-cgi/trace", { cache: "no-store" })
    .then(function (r) { return r.text(); })
    .then(function (t) {
      var m = t.match(/(?:^|\n)loc=([A-Z]{2})/);
      if (m && BLOCK_LIST.indexOf(m[1]) > -1) { blockPage(); }
    })
    .catch(function () {});
})();
